const dateMask = "99/99/9999"
const cpfCnpjInputProps = {inputMode: "numeric", pattern: "[0-9]*", maxLength: 16}

const today = () => {
  const d = new Date()
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, "0")
  const day = String(d.getDate()).padStart(2, "0")
  return `${day}/${month}/${year}`
}


export const caracteristicasFields = [
    {key: "emissao", label: "ID Emissão", required: true, md: 4, inputProps: {readOnly: true}},
    {key: "dataReferencia", label: "Data Referência", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: today()},
    {key: "dataDocumento", label: "Data Documento", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: today()},
    {key: "cetip", label: "CETIP", required: true, md: 4, normalize: "uppercase"},
    {key: "isin", label: "ISIN", md: 4, defaultValue: null},
    {key: "versaoDocumento", label: "Versão Documento", required: true, md: 4, maskType: "integer", inputProps: {maxLength: 4}, defaultValue: 0},
    {key: "numeroSerie", label: "Número Série", md: 4, mask: "9999", inputProps: {maxLength: 4}, defaultValue: 0},
    {key: "numeroEmissao", label: "Número Emissão", md: 4, mask: "9999", inputProps: {maxLength: 4}, defaultValue: 1},
    {key: "tipoAtivo", label: "Tipo Ativo", required: true, md: 4, type: "autoComplete", autoCompleteSource: "grupoAtivos"},
    {
        key: "frequenciaJuros",
        label: "Frequência Juros",
        required: true,
        md: 4,
        type: "select",
        defaultValue: 1,
        options: [
            { value: 0, label: "Zero Cupom" },
            { value: 1, label: "Mensal" },
            { value: 2, label: "Bimestral" },
            { value: 3, label: "Trimestral" },
            { value: 4, label: "Quadrimestral" },
            { value: 6, label: "Semestral" },
            { value: 12, label: "Anual" },
            { value: -1, label: "Variável" },
        ],
    },
    {
        key: "frequenciaAmortizacao",
        label: "Frequência Amortização",
        required: true,
        md: 4,
        type: "select",
        defaultValue: 1,
        options: [
            { value: 0, label: "Bullet" },
            { value: 1, label: "Mensal" },
            { value: 2, label: "Bimestral" },
            { value: 3, label: "Trimestral" },
            { value: 4, label: "Quadrimestral" },
            { value: 6, label: "Semestral" },
            { value: 12, label: "Anual" },
            { value: -1, label: "Variável" },
        ],
    },
    {key: "siteFiduciario", label: "Site Fiduciário", md: 4, inputProps: {type: "url"}, defaultValue: null},
    {
        key: "tipoOferta", label: "Tipo Oferta", md: 4, type: "radio", defaultValue: "publica", 
        items: [
            {value: "publica", label: "Pública"},
            {value: "privada", label: "Privada"},
        ],
        spacing: {mt: 1, mb: 0},
        horizontalSpacing: { xlg: -2, lg: 6, md: 8 },
    },
    {
        key: "resgateAntecipado", 
        label: "Resgate Antecipado", required: true, md: 4, type: "radio", 
        defaultValue: "nao",
        spacing: {mt: 1, mb: 0},
        horizontalSpacing: { xlg: -6, lg: 0, md: 4 },
        breakAfter: true
    },
    {key: "dataEmissao", label: "Data Emissão", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900"},
    {key: "dataIntegralizacao", label: "Data 1ª Integralização", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900"},
    {key: "dataVencimento", label: "Data Vencimento", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null},
    {key: "dataCarencia", label: "Data Carência Resgate", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900"},
    {key: "dataResgateAntecipado", label: "Data Resgate Antecipado", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null},
    {key: "dataVencimentoAntecipado", label: "Data Vencimento Antecipado", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null},
    {key: "indexador", label: "Indexador", required: true, md: 4, type: "autoComplete", autoCompleteSource: "indicadores", defaultValue:'PRE'},
    {key: "remuneracao", label: "Remuneração", required: true, md: 4, maskType: "decimal", defaultValue: "0,0"},
    {key: "puEmissao", label: "PU Emissão", md: 4, maskType: "decimal", defaultValue: "1000,0"},
    {key: "spreadEmissao", label: "Spread Emissão", md: 4, maskType: "decimal", defaultValue: "0,0"},
    {key: "prazoMedio", label: "Prazo Médio Emissão", md: 4, maskType: "decimal", defaultValue: "0,0"},
    {key: "prazoEmissao", label: "Prazo Emissão", md: 4, maskType: "decimal", defaultValue: "0,0"},
    {key: "qtdEmitida", label: "Qtd Emitida", md: 4, maskType: "decimal", defaultValue: "1,0"},
    {key: "valorSerie", label: "Valor Série", md: 4, maskType: "decimal", defaultValue: "1000,0"},
    {key: "valorTotalEmissao", label: "Valor Total Emissão", md: 4, maskType: "decimal", defaultValue: "1000,0"},
    {key: "cotaSubordinacao", label: "Cota Subordinação", md: 4, defaultValue: "Única", type: "autoComplete", autoCompleteSource: "cotaSubordinacao", },
    {key: "cascataPagamento", label: "Cascata Pagamento", md: 4, defaultValue: null},
    {key: "liquidezDiaria", label: "Liquidez Diária", required: true, md: 4, maskType: "integer", defaultValue: 0},
    {
        key: "destinacaoRecursos",
        label: "Destinação Recursos",
        md: 12,
        spacing: {mb: 2},
        defaultValue: null
    },
]

export const contrapartesFields = [
    {key: "agenciaRating", label: "CPF CNPJ Agência Rating", md: 6, type: "autoComplete", autoCompleteSource: "empresas", defaultValue: null, inputProps: cpfCnpjInputProps, maskType: "cpfCnpj"},
    {key: "auditoria", label: "CPF CNPJ Auditoria", md: 6, type: "autoComplete", autoCompleteSource: "empresas", defaultValue: null, inputProps: cpfCnpjInputProps, maskType: "cpfCnpj"},
    {key: "contaRecebedora", label: "CPF CNPJ Conta Recebedora", md: 6, type: "autoComplete", autoCompleteSource: "empresas", defaultValue: null, inputProps: cpfCnpjInputProps, maskType: "cpfCnpj"},
    {key: "registrador", label: "CPF CNPJ Registrador", md: 6, type: "autoComplete", autoCompleteSource: "empresas", defaultValue: null, inputProps: cpfCnpjInputProps, maskType: "cpfCnpj"},
    {key: "depositario", label: "CPF CNPJ Depositário", md: 6, type: "autoComplete", autoCompleteSource: "empresas", defaultValue: null, inputProps: cpfCnpjInputProps, maskType: "cpfCnpj"},
    {key: "cedente", label: "CPF CNPJ Cedente", md: 6, type: "autoComplete", autoCompleteSource: "empresas", defaultValue: null, inputProps: cpfCnpjInputProps, maskType: "cpfCnpj"},
    {key: "custodiante", label: "CPF CNPJ Custodiante", md: 6, type: "autoComplete", autoCompleteSource: "empresas", defaultValue: null, inputProps: cpfCnpjInputProps, maskType: "cpfCnpj"},
    {key: "emissor", label: "CPF CNPJ Emissor", md: 6, type: "autoComplete", autoCompleteSource: "empresas", defaultValue: null, inputProps: cpfCnpjInputProps, maskType: "cpfCnpj"},
    {
        key: "agenteFiduciario", 
        label: "CPF CNPJ Agente Fiduciário", md: 6, type: "autoComplete", autoCompleteSource: "empresas", 
        inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", 
        breakAfter: true,
        spacing: {pr: "0px !important"},
        defaultValue: null
    },
    {
        key: "devedor", 
        label: "CPF CNPJ Devedor", 
        required: true,
        md: 6, 
        type: "autoComplete", autoCompleteSource: "empresas", 
        inputProps: cpfCnpjInputProps,
        maskType: "cpfCnpj", 
        defaultValue: null
    },
    {key: "cobrigacao", label: "Coobrigação", md: 6, defaultValue: null},
    {key: "setorDevedor", label: "Setor do Devedor", md: 6},
    {key: "subSetorDevedor", label: "Subsetor do Devedor", md: 6},
    {key: "resumoDevedor", label: "Resumo Devedor", md: 12, defaultValue: null},
]

const radioFieldBase = {
    type: "radio",
    md: 4,
    direction: "row",
    columns: 2,
    itemsPerColumn: 2,
    horizontalSpacing: { xlg: -6, lg: 0, md: 4 },
    spacing: {mt: 1.25, mb: 0},
    defaultValue: "nao"
}

export const caracteristicasRadios = [
    {
        ...radioFieldBase,
        key: "conversibilidade",
        label: "Conversibilidade",
        required: true,
    },
    {
        ...radioFieldBase,
        key: "incentivada",
        label: "Incentivada",
        required: true,
    },
    {
        ...radioFieldBase,
        key: "green",
        label: "Green",
        required: true,
    },
    {
        ...radioFieldBase,
        key: "lei12431",
        label: "Lei 12.431",
        required: true,
    },
    {
        ...radioFieldBase,
        key: "lei14801",
        label: "Lei 14.801",
        required: true,
    },
    {
        ...radioFieldBase,
        key: "prePagamento",
        label: "Pré-pagamento",
    },
    {
        ...radioFieldBase,
        key: "garantiasReais",
        label: "Garantias reais",
    },
    {
        ...radioFieldBase,
        key: "garantiasFidejussorias",
        label: "Garantias Fidejussórias",
    },
    {
        ...radioFieldBase,
        key: "covenants",
        label: "Covenants",
    },
    {
        ...radioFieldBase,
        key: "repactuacaoCredito",
        label: "Repactuação Crédito",
    },
    {
        ...radioFieldBase,
        key: "mitigadorRisco",
        label: "Mitigador risco de crédito",
    },
]
